import React, { useContext, useEffect } from "react";
import { Gantt } from "gantt-task-react";
import "gantt-task-react/dist/index.css";
import { getValue, partidaDateToLocal } from "../../utils";
import { AppConfigContext } from "../../context/AppConfigContext";
import { CapacitorContext } from "../../context/CapacitorContext";
import "./charts.css";

const GanttChart = ({
  partidas,
  viewMode = "Week",
  columnWidth = 100,
  listCellWidth,
  rowHeight,
  fontSize,
  condensed = false,
  programadoColor,
  realColor,
}) => {
  const appconfig = useContext(AppConfigContext);
  const { platform } = useContext(CapacitorContext);

  const validPartidas = partidas?.filter(
    (p) => p.fecha_inicio && p.fecha_fin
  );

  const useTwoColors = Boolean(programadoColor && realColor);

  const tasks = validPartidas?.map((partida) => {
    const progreso =
      getValue(appconfig, "progress") === "money"
        ? partida.progreso
        : partida.real * 100;
    const realPct = Math.round(Number(partida.real) * 100);
    const programadoPct = Math.round(Number(partida.programado) * 100);
    const label = useTwoColors
      ? `${partida.nombre}  (${realPct}%  /  ${programadoPct}%)`
      : `${partida.nombre} (${progreso}%)`;
    const task = {
      start: partidaDateToLocal(partida.fecha_inicio),
      end: partidaDateToLocal(partida.fecha_fin),
      name: label,
      id: partida.idPartida,
      type: "task",
      dependencies: partida.predecesoras.map(({ idPartida }) => idPartida),
      progress: progreso,
      isDisabled: true,
    };
    if (useTwoColors) {
      const diff = programadoPct - realPct;
      let bgColor = realColor;
      if (diff > 10) bgColor = "#dc3545";
      else if (diff >= 5) bgColor = "#ff8008";
      task.styles = {
        backgroundColor: bgColor,
        backgroundSelectedColor: bgColor,
        progressColor: realColor,
        progressSelectedColor: realColor,
      };
    }
    return task;
  });

  useEffect(() => {
    changeWeeksLang();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tasks]);

  const changeWeeksLang = () => {
    if (platform !== "web") {
      const weekElements = document.querySelectorAll("._9w8d5");

      if (weekElements.length > 0) {
        weekElements.forEach((element) => {
          const currentText = element.innerHTML;
          element.innerHTML = currentText.replace(/W/g, "S");
        });
      }
    }
  };

  return (
    <div
      className={`gantt-scroll${condensed ? " gantt-condensed" : ""}`}
      style={{
        overflowX: condensed ? "hidden" : "auto",
        WebkitOverflowScrolling: "touch",
        touchAction: "pan-x pan-y",
      }}
    >
      {Array.isArray(partidas) ? (
        tasks?.length > 0 ? (
          <Gantt
            locale="es"
            tasks={tasks}
            preStepsCount={0}
            viewMode={viewMode}
            columnWidth={columnWidth}
            listCellWidth={listCellWidth}
            rowHeight={rowHeight}
            fontSize={fontSize}
            barProgressColor={
              useTwoColors ? realColor : getValue(appconfig, "primary")
            }
            barBackgroundColor={
              useTwoColors ? programadoColor : undefined
            }
          />
        ) : (
          <p className="text-muted">No hay partidas con fechas asignadas.</p>
        )
      ) : (
        <div className="spinner-border"></div>
      )}
    </div>
  );
};

export default GanttChart;
